import React, { useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Analise() {
  const [arquivos, setArquivos] = useState([]);
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!arquivos.length) {
      toast.warning("Selecione ao menos um arquivo.");
      return;
    }

    const form = new FormData();
    form.append("documento", arquivos[0]);

    try {
      setLoading(true);
      toast.warning("Análise jurídica em andamento");
      const res = await api.post("/AI/analise", form, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      let rawResponse = res.data.resposta || "";
      const cleaned = rawResponse.replace(/```json|```/g, "").trim();

      let parsedData;
      try {
        parsedData = JSON.parse(cleaned);
      } catch (err) {
        console.error("Erro ao parsear JSON da resposta da IA", err);
        toast.error("Erro ao processar a resposta da IA.");

        setLoading(false);
        return;
      }

      setLinks(res.data.arquivos || []);

      if (res.data.responsePrisma?.id) {
        navigate(`/detailsAnaliseJuridica/${res.data.responsePrisma.id}`);
      }
    } catch (err) {
      console.error(err);
      toast.error("Erro ao processar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="layout">
      <div className="card" style={{ maxWidth: "600px" }}>
        <h2>Análise Jurídica e Financeira</h2>
        <form onSubmit={handleUpload} className="upload-form">
          <label htmlFor="file-upload" className="drop-zone">
            <input
              id="file-upload"
              type="file"
              onChange={(e) => setArquivos([e.target.files[0]])} // só 1 arquivo
              style={{ display: "none" }}
              disabled={loading}
            />
            <span>📁 Clique ou arraste arquivos aqui</span>
            {arquivos.length > 0 && (
              <p
                style={{
                  fontSize: "0.9rem",
                  color: "#333",
                  marginTop: "0.5rem",
                }}
              >
                {arquivos.length} arquivo(s) selecionado(s)
              </p>
            )}
          </label>

          {/* Botão desaparece no loading */}
          {!loading && (
            <button
              className="button button-azul"
              type="submit"
              disabled={loading}
            >
              Enviar para IA
            </button>
          )}
        </form>

        {/* Spinner aparece somente no loading */}
        {loading && (
          <div
            className="loading-spinner"
            role="status"
            aria-label="Carregando..."
            style={{ margin: "20px auto" }}
          />
        )}

        <div style={{ marginTop: 20 }}>
          {links.length > 0 && (
            <>
              <h4>Links dos arquivos:</h4>
              <ul>
                {links.map((link, i) => (
                  <li key={i}>
                    <a href={link} target="_blank" rel="noreferrer">
                      Arquivo {i + 1}
                    </a>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>

        <style>{`
          .loading-spinner {
            width: 40px;
            height: 40px;
            border: 4px solid #93c5fd; /* azul claro para a borda */
            border-top-color: #2563eb; /* azul do botão */
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }

          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
}
